import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home/AnimatedHome.tsx");
